import { Node } from "../generated/UsedGeneratedTypes";
import { GenericTag, InternationalizeFn, LocalTag } from "./LocalTag";

type LocalNameFunction = (name: string) => string;
type LocalDescriptionFunction = (name: string) => string;
type GetTagsFunction = (name: string) => GenericTag[];

export class LocalNode implements Node {
  level: number;
  nodeName: string;
  componentKey: string;
  columnToLookUpForRecursive: string;
  parent: string;
  children: LocalNode[];
  depends: string[];
  order: number;
  isRecursive: boolean;
  dataNameLocal: string;
  dataDescriptionLocal: string;
  tags: LocalTag[];
  id: string;

  constructor(
    node: Node,
    getLocalName: LocalNameFunction,
    getLocalDescription: LocalDescriptionFunction,
    getTags: GetTagsFunction,
    internationalize?: InternationalizeFn,
  ) {
    this.id = node.nodeName;
    this.nodeName = node.nodeName;
    this.dataNameLocal = getLocalName(node.nodeName);
    this.dataDescriptionLocal = getLocalDescription(node.nodeName);
    this.parent = node.parent;
    this.isRecursive = node.isRecursive;
    this.componentKey = node.componentKey;
    this.order = node.order || 999;
    this.depends = node.depends;
    this.level = node.level;
    this.columnToLookUpForRecursive = node.columnToLookUpForRecursive;
    this.children = node.children?.map(
      (n: Node) => new LocalNode(n, getLocalName, getLocalDescription, getTags, internationalize),
    ) || [];
    this.tags = getTags(node.nodeName)?.map((tag: GenericTag) =>
      new LocalTag(tag, internationalize),
    ) || [];
  }
}
